import {Box, Divider} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {AppConfirmationDialog, AppConfirmationDialogRefType} from 'components/dialogs';
import {AppTooltip} from 'components/toolip';
import {FeautureGuard} from 'guards';
import {useRemoveItemDatasByIds} from 'hooks';
import {Trash} from 'iconsax-react';
import {ItemDataResponse} from 'models/board';
import {TenantSettingsKeysEnum} from 'models/settings';
import React, {useEffect, useRef} from 'react';
import {AiTwotoneNotification} from 'react-icons/ai';

interface ItemDialogSideBarActionsProps {
    onRemoveItemResponseHandler: (itemId: string) => void;
    itemDataId: string;
    item: ItemDataResponse;
}

export const ItemDialogSideBarActions: React.FC<ItemDialogSideBarActionsProps> = ({
    onRemoveItemResponseHandler,
    itemDataId,
    item,
}) => {
    const confirmationDialiogRef = useRef<AppConfirmationDialogRefType>(null);

    const {removeItemDatasById, removeItemDatasByIdLoading, removeItemDatasByIdResponse} = useRemoveItemDatasByIds();
    const handleDeleteHanlder = () => {
        removeItemDatasById([itemDataId]);
    };
    useEffect(() => {
        if (removeItemDatasByIdResponse && !removeItemDatasByIdLoading && itemDataId) {
            onRemoveItemResponseHandler(itemDataId);
        }
    }, [removeItemDatasByIdLoading, removeItemDatasByIdResponse, itemDataId]);

    return (
        <Box>
            <AppTooltip title="Delete Item">
                <AppIconButton
                    color="error"
                    onClick={() => confirmationDialiogRef.current?.handleOpen()}
                    sx={{ml: 1, fontSize: '0.875rem'}}
                >
                    <Trash variant="Bold" />
                </AppIconButton>
            </AppTooltip>

            <AppConfirmationDialog
                loading={removeItemDatasByIdLoading}
                renderElement={(_open, handleOpen) => <></>}
                ref={confirmationDialiogRef}
                icon={<Trash variant="Bold" />}
                onConfirmClick={(_open, _handleOpen, handleClose) => {
                    handleDeleteHanlder();
                }}
                title="Delete Item"
                description="Are you sure you want to delete this item?"
            />
        </Box>
    );
};

export default ItemDialogSideBarActions;
